import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

export const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    // backgroundColor: 'gray',
    outline: '1px solid black',
    height: (props) => props.height ?? '33vh',
    width: '100%',
  },
  video: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: '0px',
    left: '0px',
    objectFit: 'contain',
  },
}));

VideoTile.propTypes = {
  height: PropTypes.string,
  videoTileId: PropTypes.number,
  thisAttendeeId: PropTypes.string.isRequired,
  selectSpeaker: PropTypes.func,
  isSelected: PropTypes.bool,
  children: PropTypes.node,
};
export default function VideoTile(props) {
  const { videoTileId, children } = props;
  const classes = useStyles(props);
  const videoElement = useRef(null);
  const { audioVideo } = useSelector(({ chime }) => ({
    audioVideo: chime.audioVideo,
  }));

  useEffect(() => {
    audioVideo.bindVideoElement(videoTileId, videoElement.current);
    return () => {
      audioVideo.unbindVideoElement(videoTileId);
    };
    // eslint-disable-next-line
  }, [videoTileId]);

  return (
    <div data-testid="video-tile-root" className={classes.root}>
      <video data-testid="video-tile" className={classes.video} ref={videoElement} />
      {children}
    </div>
  );
}
